module.exports = __webpack_public_path__ + "static/img/bssm-ban.fbd23eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bssm-ban.jpg
// module id = Rw7g
// module chunks = 1